import React from "react"
import { Layout } from "../layouts/Layout"
import {RemoveScroll} from 'react-remove-scroll';

export default ({ data }) => {
  return (
    <Layout>
      <RemoveScroll>
      <iframe class="airtable-embed" src="https://airtable.com/embed/shr9b1sqM5qplBdQp?backgroundColor=green&viewControls=on" frameborder="0" onmousewheel="" width="100%" height="600" style={{background: "transparent", border: "1px solid #ccc"}}></iframe>
      </RemoveScroll>
    </Layout>
  )
}

